<template>
  <div ref="content" class="content background2">
    <div ref="search">
      <SearchList ref="searchContent" :searchList="searchList"></SearchList>
    </div>
    <div ref="btnList">
      <BtnList ref="btn" :btnList="btnList"></BtnList>
    </div>
    <div ref="tableList" class="list" :style="{ 'padding-top': paddingTop }">
      <List
        ref="list"
        :tableData="tableData"
        :tableList="tableList"
        :pageSize="pageSize"
        :pageNo="pageNo"
        @parentMethod="getInfo"
      >
      </List>
    </div>
    <div ref="page" class="page">
      <Page
        ref="pageModel"
        :total="pageCount"
        :display="pageSize"
        :pagegroup="3"
        :currentspage="1"
        @parentMethod="search"
      ></Page>
    </div>

    <el-dialog
      title="绑定客户"
      :center="true"
      :visible.sync="dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="700px"
      custom-class="dialog-style"
    >
      <div class="dialog-content">
        <el-table
          ref="multipleTableData"
          :data="tableData1"
          style="width: 100%"
          height="450"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            label="客户名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="abbreviation"
            label="客户简称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="contact"
            label="联系人"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="contactPhone"
            label="联系人电话"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="bindingCustomer()">绑 订</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="绑定区域"
      :center="true"
      :visible.sync="dialogArea"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="700px"
      custom-class="dialog-style"
    >
      <div class="dialog-content">
        <el-table
          ref="multipleAreaTableData"
          :data="tableAreaData"
          style="width: 100%"
          height="450"
          @selection-change="handleSelectionChangeArea"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectableArea"
          ></el-table-column>
          <el-table-column
            prop="city"
            label="区域名称"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogArea = false">取 消</el-button>
        <el-button type="primary" @click="bindingUserArea()">绑 订</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/common/list.css";
import SearchList from "@/components/list/searchList";
import BtnList from "@/components/list/btnList";
import List from "@/components/list/list";
import Page from "@/components/common/page";
import User from "@/assets/js/system/user.js";
import Contract from "@/assets/js/contract/contract.js";
import CommonJs from "@/assets/js/common/common.js";

export default {
  name: "list",
  components: {
    List,
    SearchList,
    BtnList,
    Page,
  },
  data() {
    const $this = this;
    return {
      paddingTop: 0,
      customerId: "",
      customerName: "",
      userTypeList: [],
      menuList: [],
      searchList: [
        {
          searchLabel: "人员姓名",
          searchValue: "",
          searchType: 0,
          searchWidth: "25%",
          searchBr: false,
          column: "fullName",
        },
        {
          searchLabel: "人员类型",
          searchValue: "",
          searchType: 1,
          searchTermList: [],
          searchWidth: "25%",
          searchBr: false,
          column: "roleId",
        },
        {
          searchLabel: "电话号码",
          searchValue: "",
          searchType: 0,
          searchWidth: "25%",
          searchBr: false,
          column: "mobile",
        },
        {
          searchLabel: "身份证",
          searchValue: "",
          searchType: 0,
          searchWidth: "25%",
          searchBr: false,
          column: "idCard",
        },
      ],
      tableList: [
        {
          column: "customerName",
          title: "所属客户",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "username",
          title: "登录账号",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "fullName",
          title: "人员姓名",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "roleId",
          title: "人员类型",
          headerAlign: "center",
          align: "center",
          termList: [],
          width: "20%",
        },
        {
          column: "mobile",
          title: "电话号码",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
        {
          column: "idCard",
          title: "身份证",
          headerAlign: "center",
          align: "center",
          width: "20%",
        },
      ],
      tableData: [],
      tableInfo: {},
      pageCount: 0,
      pageSize: 0,
      pageNo: 1,
      tableData1: [],
      tableAreaData: [],
      customerIds: [],
      areaCodes: [],
      dialog: false,
      dialogArea: false,
      btnList: [],
    };
  },
  methods: {
    getContomerAllList() {},
    // 绑定客户
    selectTable() {
      let that = this;
      let param = {};
      param.userId = this.tableInfo.userId;
      User.getChooseCustomerList(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.$refs.multipleTableData.clearSelection();
            this.customerIds = [];
            this.customerIds = data.data;

            console.log(this.customerIds);
            let selectlist = [];
            User.getContomerAllList()
              .then((response) => {
                const data = response.data;
                if (data.code == 1) {
                  this.tableData1 = data.data;
                  this.tableData1.forEach((item1, index1) => {
                    this.customerIds.forEach((item2, index2) => {
                      if (item1.id == item2.customerId) {
                        if (this.customerIds[index2].type == 0) {
                          this.tableData1[index1].type =
                            this.customerIds[index2].type;
                        }
                        selectlist.push(item1);
                      }
                    });
                  });

                  this.$nextTick(() => {
                    selectlist.forEach((item) => {
                      this.$refs.multipleTableData.toggleRowSelection(item, true);
                    });
                  });
                } else {
                  this.utils.tipsAlert(data.message);
                }
              })
              .catch((response) => {
                console.log(response);
              });
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },
    // 绑定区域
    selectAreaTable() {
      let param = {};
      param.userId = this.tableInfo.userId;
      CommonJs.getChooseCustomerCityName(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.$refs.multipleAreaTableData.clearSelection();
            this.areaCodes = data.data;
            let selectlist = [];
            this.tableAreaData.forEach((item1, index1) => {
              this.areaCodes.forEach((item2, index2) => {

                item1.areaCode = item1.areaCode.slice(0,4);
                console.log(item1.areaCode + "," + item2.areaCode);
                if (item1.areaCode == item2.areaCode) {
                  this.tableAreaData[index1].type = this.areaCodes[index2].type;
                  selectlist.push(item1);
                }
              });
            });
            selectlist.forEach((item) => {
              this.$refs.multipleAreaTableData.toggleRowSelection(item, true);
            });
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },

    checkSelectable(row) {
      if (row.type != undefined) {
        return false;
      } else {
        return true;
      }
    },

    checkSelectableArea(row) {
      if (row.type != undefined) {
        return false;
      } else {
        return true;
      }
    },
    post(param) {
      User.getUserList(param)
        .then((response) => {
          const data = response.data;
          this.pageCount = data.data.total;
          this.pageNo = data.data.current;
          this.$refs["pageModel"].setCurrent(this.pageNo);
          this.tableData = data.data.records;
        })
        .catch((response) => {
          console.log(response);
        });
    },
    //绑定客户
    bindingCustomer() {
      let param = {};
      param.userId = this.tableInfo.userId;
      let customerIdList = [];
      this.customerIds.forEach((item, index) => {
        customerIdList.push(item.id);
      });
      param.customerList = customerIdList;
      User.updateUserCustomerRelation(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.utils.tipsAlert("绑定成功");
            this.dialog = false;
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },

    handleSelectionChange(val) {
      this.customerIds = val;
    },
    //绑定区域
    bindingUserArea() {
      let param = {};
      param.userId = this.tableInfo.userId;
      let areaCodeList = [];
      this.areaCodes.forEach((item, index) => {
        areaCodeList.push(item.areaCode);
      });
      param.areaCodeList = areaCodeList;
      if (areaCodeList.length <= 0) {
        this.utils.tipsAlert("必须选择一项");
        return;
      }
      User.AddUserArea(param)
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.utils.tipsAlert("绑定成功");
            this.dialogArea = false;
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },

    handleSelectionChangeArea(val) {
      this.areaCodes = val;
    },

    //导出
    getExport() {
      var param = this.$refs.searchContent.getSearchParam();
      User.getAllUser(param)
        .then((response) => {
          const data = response.data;
          let list = [];
          data.data.forEach((item, index) => {
            var param = {};
            param.customerName =
              item.customerName == null ? " " : item.customerName;
            param.username = item.username == null ? " " : item.username;
            param.fullName = item.fullName == null ? " " : item.fullName;
            param.mobile = item.mobile == null ? " " : item.mobile;
            param.idCard = item.idCard == null ? " " : item.idCard;
            this.userTypeList.forEach((item1) => {
              if (item1.id === item.roleId) {
                param.roleName = item1.name;
              }
            });
            list.push(param);
          });
          this.btnList[3].sheet[0].table = list;
        })
        .catch((response) => {
          console.log(response);
        });
    },
    search(param) {
      var dataParam = this.$refs.searchContent.getSearchParam();
      var newParam = Object.assign(param, dataParam);
      this.post(newParam);
      this.getExport();
    },
    getWindowHeight() {
      let height = "";
      height =
        this.$refs.tableList.clientHeight -
        (this.$refs.search.clientHeight +
          this.$refs.btnList.clientHeight +
          20) -
        60;
      this.height = height;
      if (height > 550) {
        let line = parseInt((height - 10) / 50);
        if (this.pageSize != line) {
          this.pageSize = line;
        }
      } else {
        if (this.pageSize != 10) {
          this.pageSize = 10;
        }
      }
      this.search({
        pageNo: 1,
        pageSize: this.pageSize,
      });
    },
    getInfo(info) {
      this.tableInfo = info;
    },
    async getRoleList() {
      User.getRoleList1()
        .then((response) => {
          const data = response.data.data;
          let list = [];
          for (var i = 0; i < data.length; i++) {
            list.push({
              id: data[i].roleId.toString(),
              name: data[i].roleName,
            });
          }
          this.searchList[1].searchTermList = list;
          this.btnList[0].columnList[3].columnTermList = list;
          this.btnList[1].columnList[3].columnTermList = list;
          this.tableList[3].termList = list;
          this.userTypeList = list;
        })
        .catch((response) => {
          console.log(response);
        });
    },
    async getContomerAllList() {
      User.getContomerAllList()
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.tableData1 = data.data;
          } else {
            this.utils.tipsAlert(data.message);
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },
    async getAllCustomerCityName() {
      CommonJs.getAllCustomerCityName()
        .then((response) => {
          const data = response.data;
          if (data.code == 1) {
            this.tableAreaData = data.data;
          } else {
            this.utils.tipsAlert(data.message);
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },
  },
  created() {
    this.menuList = this.$store.getters.getMenuPermission;
    const $this = this;
    if (this.menuList.indexOf("CD_611") != -1) {
      this.btnList.push({
        btnLabel: "新增",
        btnType: 1,
        btnPosition: "left",
        title: "新增",
        columnList: [
          {
            columnLabel: "所属客户",
            value: "",
            column: "customerName",
            columnType: 8,
            placeholder: "请输入所属客户",
            valueKey: "customerName",
            columnTermList: [],
            InputFun: function (queryString, cb) {
              Contract.getByName(queryString)
                .then((response) => {
                  const data = response.data;
                  if (data.code == 1) {
                    cb(data.data);
                  }
                })
                .catch((response) => {
                  console.log(response);
                });
            },
            selectFun: function (val) {
              $this.customerId = val.id;
              $this.customerName = val.customerName;
            },
          },
          {
            columnLabel: "登录账号",
            value: "",
            column: "username",
            columnType: 0,
            placeholder: "请输入登录账号",
          },
          {
            columnLabel: "人员姓名",
            value: "",
            column: "fullName",
            columnType: 0,
            placeholder: "请输入人员姓名",
          },
          {
            columnLabel: "人员类型",
            value: "",
            column: "roleId",
            columnType: 1,
            placeholder: "请选择人员类型",
            columnTermList: [],
          },
          {
            columnLabel: "电话号码",
            value: "",
            column: "mobile",
            columnType: 0,
            placeholder: "请输入电话号码",
          },
          {
            columnLabel: "身份证",
            value: "",
            column: "idCard",
            columnType: 0,
            placeholder: "请输入身份证",
          },
        ],
        btnClick: function (tip) {
          tip();
          $this.btnList[0].columnList.forEach(function (item, index) {
            item.value = "";
          });
        },
        btnFun: function (tip, info) {
          info.customerId = $this.customerId;
          if (info.customerName == "") {
            $this.utils.tipsAlert("请输入所属客户");
            return;
          }
          if (info.username == "") {
            $this.utils.tipsAlert("请输入登录账号");
            return;
          }
          if (info.fullName == "") {
            $this.utils.tipsAlert("请输入人员姓名");
            return;
          }
          if (info.roleId === "") {
            $this.utils.tipsAlert("请选择人员类型");
            return;
          }
          if (info.mobile == "") {
            $this.utils.tipsAlert("请输入电话号码");
            return;
          }
          if (info.idCard == "") {
            $this.utils.tipsAlert("请输入身份证");
            return;
          }
          User.addNewUser(info)
            .then((response) => {
              const data = response.data;
              if (data.code == 1) {
                $this.utils.saveAlert();
                $this.search({
                  pageNo: 1,
                  pageSize: $this.pageSize,
                });
                $this.btnList[0].columnList.forEach(function (item, index) {
                  item.value = "";
                });
                tip();
              } else {
                $this.utils.tipsAlert(data.message);
              }
            })
            .catch((response) => {
              console.log(response);
            });
        },
      });
    }
    if (this.menuList.indexOf("CD_612") != -1) {
      this.btnList.push({
        btnLabel: "编辑",
        btnType: 4,
        btnPosition: "left",
        title: "编辑",
        columnList: [
          {
            columnLabel: "所属客户",
            value: "",
            column: "customerName",
            columnType: 8,
            placeholder: "请输入所属客户",
            valueKey: "customerName",
            columnTermList: [],
            InputFun: function (queryString, cb) {
              Contract.getByName(queryString)
                .then((response) => {
                  const data = response.data;
                  if (data.code == 1) {
                    cb(data.data);
                  }
                })
                .catch((response) => {
                  console.log(response);
                });
            },
            selectFun: function (val) {
              $this.customerId = val.id;
              $this.customerName = val.customerName;
            },
          },
          {
            columnLabel: "登录账号",
            value: "",
            column: "username",
            columnType: 0,
            placeholder: "请输入登录账号",
          },
          {
            columnLabel: "人员姓名",
            value: "",
            column: "fullName",
            columnType: 0,
            placeholder: "请输入人员姓名",
          },
          {
            columnLabel: "人员类型",
            value: "",
            column: "roleId",
            columnType: 1,
            placeholder: "请选择",
            columnTermList: [],
          },
          {
            columnLabel: "电话号码",
            value: "",
            column: "mobile",
            columnType: 0,
            placeholder: "请输入电话号码",
          },
          {
            columnLabel: "身份证",
            value: "",
            column: "idCard",
            columnType: 0,
            placeholder: "请输入身份证",
          },
          // {
          //   columnLabel: "微信OpenId",
          //   value: "",
          //   column: "openid",
          //   columnType: 0,
          //   placeholder: "",
          // },
        ],
        btnClick: function (tip) {
          if (Object.keys($this.tableInfo).length > 0) {
            tip();
            $this.customerId = $this.tableInfo.customerId;
            $this.customerName = $this.tableInfo.customerName;
            $this.btnList[1].columnList.forEach(function (item, index) {
              item.value = $this.tableInfo[item.column];
            });
          } else {
            $this.utils.tipsAlert("请选择数据");
          }
        },
        btnFun: function (tip, info) {
          info.userId = $this.tableInfo.userId;
          info.customerId = $this.customerId;
          if (info.customerName == "") {
            $this.utils.tipsAlert("请输入所属客户");
            return;
          }
          if (info.username == "") {
            $this.utils.tipsAlert("请输入登录账号");
            return;
          }
          if (info.fullName == "") {
            $this.utils.tipsAlert("请输入人员姓名");
            return;
          }
          if (info.roleId === "") {
            $this.utils.tipsAlert("请选择人员类型");
            return;
          }
          if (info.mobile == "") {
            $this.utils.tipsAlert("请输入电话号码");
            return;
          }
          if (info.idCard == "") {
            $this.utils.tipsAlert("请输入身份证");
            return;
          }
          User.updataNewUser(info, $this.tableInfo.userId)
            .then((response) => {
              const data = response.data;
              if (data.code == 1) {
                $this.utils.editAlert();
                $this.search({
                  pageNo: 1,
                  pageSize: $this.pageSize,
                });
                tip();
              } else {
                $this.utils.tipsAlert(data.message);
              }
            })
            .catch((response) => {
              console.log(response);
            });
        },
      });
    }
    if (this.menuList.indexOf("CD_613") != -1) {
      this.btnList.push({
        btnLabel: "删除",
        btnType: 0,
        btnPosition: "left",
        btnFun: function () {
          if (Object.keys($this.tableInfo).length > 0) {
            $this
              .$confirm("是否删除这个用户?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                var info = [$this.tableInfo.userId];
                User.delNewUser(info)
                  .then((response) => {
                    const data = response.data;
                    if (data.code == 1) {
                      $this.utils.delAlert();
                    } else {
                      $this.utils.tipsAlert(data.message);
                    }
                    $this.search({
                      pageNo: 1,
                      pageSize: $this.pageSize,
                    });
                  })
                  .catch((response) => {
                    console.log(response);
                  });
              });
          } else {
            $this.utils.tipsAlert("请选择数据");
          }
        },
      });
    }
    this.btnList = this.btnList.concat([
      {
        btnLabel: "导出",
        btnType: 2,
        btnPosition: "left",
        filename: "用户列表",
        sheet: [
          {
            title: "用户表",
            tHeader: [
              "所属客户",
              "登录账户",
              "人员姓名",
              "人员类型",
              "电话号码",
              "身份证",
            ],
            keys: [
              "customerName",
              "username",
              "fullName",
              "roleName",
              "mobile",
              "idCard",
            ],
            table: [],
            sheetName: "用户",
            cellStyle: [
              {
                cell: "A1",
                font: {
                  name: "黑体",
                  sz: "18px",
                },
              },
            ],
          },
        ],
      },
      {
        btnLabel: "重置密码",
        btnType: 0,
        btnPosition: "left",
        btnFun: function () {
          if (Object.keys($this.tableInfo).length > 0) {
            $this
              .$confirm("是否需要重置这个用户密码?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                let param = {};
                param.userId = $this.tableInfo.userId;
                param.password = "123456";
                User.updataNewUser(param, $this.tableInfo.userId)
                  .then((response) => {
                    const data = response.data;
                    if (data.code == 1) {
                      $this.utils.tipsAlert("重置成功，已恢复到默认密码123456");
                      $this.search({
                        pageNo: 1,
                        pageSize: $this.pageSize,
                      });
                    } else {
                      $this.utils.tipsAlert(data.message);
                    }
                  })
                  .catch((response) => {
                    console.log(response);
                  });
              });
          } else {
            $this.utils.tipsAlert("请选择数据");
          }
        },
      },
      {
        btnLabel: "绑定客户",
        btnType: 0,
        btnPosition: "left",
        btnFun: function () {
          if (Object.keys($this.tableInfo).length > 0) {
            $this.dialog = true;
            $this.selectTable();
          } else {
            $this.utils.tipsAlert("请选择数据");
          }
        },
      },
      {
        btnLabel: "绑定区域",
        btnType: 0,
        btnPosition: "left",
        btnFun: function () {
          if (Object.keys($this.tableInfo).length > 0) {
            $this.dialogArea = true;
            $this.selectAreaTable();
          } else {
            $this.utils.tipsAlert("请选择数据");
          }
        },
      },
      {
        btnLabel: "查询",
        btnType: 3,
        btnPosition: "right",
        btnFun: function () {
          $this.search({
            pageNo: 1,
            pageSize: $this.pageSize,
          });
        },
      },
    ]);
  },
  mounted() {
    this.paddingTop =
      this.$refs.search.clientHeight +
      this.$refs.btnList.clientHeight +
      20 +
      "px";
    this.getRoleList();
    this.getContomerAllList();
    this.getAllCustomerCityName();
    this.getWindowHeight();
    // this.menuList = this.$store.getters.getMenuPermission;
    if (this.menuList.indexOf("CD_610") != -1) {
      this.activeName = this.$route.path;
    } else {
      if (this.menuList.indexOf("CD_620") != -1) {
        this.$router.push({
          path: "/static/system/role",
        });
        return;
      }
      if (this.menuList.indexOf("CD_630") != -1) {
        this.$router.push({
          path: "/static/system/area",
        });
        return;
      }
      if (this.menuList.indexOf("CD_640") != -1) {
        this.$router.push({
          path: "/static/system/time",
        });
        return;
      }
      if (this.menuList.indexOf("CD_650") != -1) {
        this.$router.push({
          path: "/static/system/customer",
        });
        return;
      }
      if (this.menuList.indexOf("CD_660") != -1) {
        this.$router.push({
          path: "/static/system/equipment",
        });
        return;
      }
      if (this.menuList.indexOf("CD_670") != -1) {
        this.$router.push({
          path: "/static/system/dictionary",
        });
        return;
      }
    }
    window.onresize = () => {
      this.getWindowHeight();
      this.$refs.list.getHeight();
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/manage.vue